
import { useEffect, RefObject } from 'react';

export const useDetectOutsideClick = (ref: RefObject<HTMLElement>, callback: () => void) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            // Bỏ qua click vào nội dung render qua React Portal ra thẳng document.body (vd popup của
            // DateInputCustom) — nội dung đó nằm ngoài DOM tree của `ref` dù về mặt UI vẫn "ở trong"
            // modal/dropdown đang mở, nên không tính là click-ra-ngoài. Yêu cầu phần tử portal tự đánh
            // dấu bằng `data-portal="true"`.
            if (target instanceof Element && target.closest('[data-portal="true"]')) {
                return;
            }

            if (ref.current && !ref.current.contains(target)) {
                callback();
            }
        };

        const handleEscKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                callback();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKey);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [ref, callback]);
};
